import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import { Dropdown, DropdownButton } from "react-bootstrap"
import { toast } from "react-toastify"
import axiosProvider from "../lib/AxiosProvider"
import { admin } from "../config/apiEndpoints"

const EnergyDispensedChart = ({ chartLoading, setChartLoading }) => {
  const [filterTitle, setFilterTitle] = useState("All")
  const [filter, setFilter] = useState("all")
  const allData = []

  const allCategories = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  const [series, setSeries] = useState([
    {
      name: "Energy Dispensed",
      data: allData,
    },
  ])

  const [options, setOptions] = useState({
    chart: {
      type: "area",
      fontFamily: `'Poppins', sans-serif`,
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    grid: {
      borderColor: "#e5e5e5",
      strokeDashArray: 4,
      yaxis: { lines: { show: true } },
    },
    title: {
      text: "Energy Dispensed",
      offsetX: -10,
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#263238",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories: allCategories,
      labels: {
        style: { colors: "#000", fontSize: "12px" },
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "#78909C",
        height: 6,
      },
    },
    yaxis: {
      title: {
        text: "kWh",
        style: {
          fontSize: "14px",
          fontWeight: "400",
          color: "#777",
        },
      },
      labels: {
        style: { colors: "#000", fontSize: "12px" },
      },
    },
    tooltip: {
      x: { format: "MMM" },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      floating: true,
    },
  })

  const handleFilterChange = (filterKey, label) => {
    setFilter(filterKey)
    setFilterTitle(label)
  }

  const fetchData = async () => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: `${admin.dashboardEnergyDispensed}?filter=${filter}`,
      })

      if (response?.data?.code === 200) {
        const apiData = response?.data?.data || []

        const formattedCategories = apiData.map((item) => {
          const dateObj = new Date(item.date)
          return dateObj.toLocaleString("default", {
            month: "short",
            year: "2-digit",
          })
        })

        const consumptionData = apiData.map((item) =>
          parseFloat(
            (item?.consumption == null ? 0 : item?.consumption).toFixed(2)
          )
        )

        setSeries([{ name: "Energy Dispensed", data: consumptionData }])
        setOptions((prev) => ({
          ...prev,
          xaxis: {
            ...prev.xaxis,
            categories: formattedCategories,
          },
        }))
        setChartLoading(false)
      }
    } catch (error) {
      toast.error(error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filterTitle])

  return (
    <>
      {!chartLoading && (
        <>
          <DropdownButton
            id="dropdown-basic-button"
            title={
              <div className="filterdropdwon_icontext">
                <i className="icon_main filter_chart"></i>
                {` ${filterTitle}`}
              </div>
            }
            variant="outline_filter"
          >
            <Dropdown.Item onClick={() => handleFilterChange("all", "All")}>
              All
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleFilterChange("yesterday", "Yesterday")}
            >
              Yesterday
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleFilterChange("last_week", "Last Week")}
            >
              Last Week
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleFilterChange("last_month", "Last Month")}
            >
              Last Month
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() =>
                handleFilterChange("last_3_month", "Last 3 Months")
              }
            >
              Last 3 Months
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() =>
                handleFilterChange("last_6_month", "Last 6 Months")
              }
            >
              Last 6 Months
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleFilterChange("last_year", "Last 12 Months")}
            >
              Last 12 Months
            </Dropdown.Item>
          </DropdownButton>

          <ReactApexChart
            options={options}
            series={series}
            type="area"
            height={340}
          />
        </>
      )}
    </>
  )
}

export default EnergyDispensedChart
